module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mint-directive-if",
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68eabcca","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/directive-if/src/directive-if.vue
// module id = 442
// module chunks = 0